import { FC, ReactNode } from 'react';
import { Root } from './styled';

type Props = {
  children: ReactNode;
};

const PageWrapper: FC<Props> = ({ children }) => {
  return <Root>{children}</Root>;
};

export default PageWrapper;
